import { BaseReportRequest } from '../../core/models/report-request.models';
import { ReportSection } from '../../core/models/report-sections';

export interface CreateItineraryReportRequest extends BaseReportRequest {
  eventId: string;
  sections?: ReportSection[];
}

export interface ItineraryActivityData {
  activityId: string;
  subject?: string;
  date: string;
  timeZone: string;
  participants: { ipreoCompanyId: number }[];
}

export class CreateItineraryReportDto {
  eventId!: string;
  eventName!: string;
  startDate?: string | null;
  endDate?: string | null;
  eventType?: string;
  activities?: ItineraryActivityData[];

  static create(args: {
    eventId: string;
    eventName: string;
    startDate?: string | null;
    endDate?: string | null;
    eventType?: string;
    activities?: ItineraryActivityData[];
  }): CreateItineraryReportDto {
    return {
      eventId: args.eventId,
      eventName: args.eventName,
      startDate: args.startDate,
      endDate: args.endDate,
      eventType: args.eventType,
      activities: args.activities
    };
  }
}
